// src/components/ErrorPage.js
import React from 'react';
import errorImage from '../../assets/images/errorImg.gif';
import { useTheme } from '../../theme/ThemeProvider';

const ErrorPage = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-100 via-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 text-black dark:text-white">
            <div className="flex flex-col items-center justify-center min-h-screen">
                <img
                    src={errorImage}
                    alt="404 Error"
                    className="w-100 h-68 mb-8"
                />
                <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">404 - Page Not Found</h1>
                <p className="text-lg text-gray-600 dark:text-white mb-8">
                    Oops! The page you are looking for does not exist.
                </p>
                <a
                    href="/"
                    className="flex items-center gap-2 px-4 py-2 text-base font-medium text-white bg-gradient-to-r from-blue-500 to-purple-500 rounded-full hover:opacity-90 transition-all duration-300 shadow-md hover:shadow-lg"
                >
                    Go Back Home
                </a>
            </div>
        </div>
    );
};



export default ErrorPage;
